import { navigationService } from '__common/services/navigationService';
import { getProductName, isNxtTilt, isSMAscenderFlush, isSMHD, isSMLT, isSMTiltPRWithAscender } from '__common/constants/products';
import { state } from '__common/store';
import { anyPanelsDrawn, allRoofsHasPanels, allRoofsHaveRoofPitch } from '__editor/googleMapsRoofsSelector/components/drawingManager/drawingManagerHelper';
import { panelsEditorEnabled } from 'projectDesign/projectDesign';

export function changeUrlOnFirstAutoSave(projectId: string) {
  if (!projectId || typeof window === 'undefined') {
    return;
  }

  const path = window.location.pathname;
  const { saveLoadProject, projectConfiguration: { productId } } = state();
  // This rewrite runs on every socket success that carries a pk, including a
  // save that has already asked to open the BOM. Replacing back to the design
  // URL at that point makes redirectBom push the BOM URL again.
  if (path.includes('/project/bom/') || (saveLoadProject && saveLoadProject.pk)) {
    return;
  }

  let productName;

  if (isSMLT(productId) || isSMHD(productId) || isSMAscenderFlush(productId)) {
    productName = getProductName(9);
  } else if (isSMTiltPRWithAscender(productId)) {
    productName = getProductName(30);
  } else {
    productName = getProductName(productId);

  }

  if (!location.href.includes(projectId)) {
    navigationService.replace(`/project/design/${productName}/${projectId}`);
  }
}

export function isOnDesignPage() {
  return location.href.includes('project/design');
}

export function shouldAutoSave(opts?: { allowInPanelsEditor?: boolean }) {
  const { saveLoadProject: { autoSaving, isLoading }, panels: { exposureRecalculation } } = state();
  const allowInPanelsEditor = opts && opts.allowInPanelsEditor;
  if (allowInPanelsEditor) {
    return anyPanelsDrawn() && isOnDesignPage() && !autoSaving && !isLoading && allRoofsHasPanels() && allRoofsHaveRoofPitch();
  }
  return anyPanelsDrawn() && isOnDesignPage() && !autoSaving && !isLoading && !exposureRecalculation && !panelsEditorEnabled() && allRoofsHasPanels() && allRoofsHaveRoofPitch();
}

export function shouldAutoSaveInPanelEditor() {
  const { saveLoadProject: { autoSaving, isLoading }, panels: { exposureRecalculation } } = state();
  return anyPanelsDrawn() && isOnDesignPage() && !autoSaving && !isLoading && !exposureRecalculation && allRoofsHasPanels() && allRoofsHaveRoofPitch();
}
